import React from 'react';
import { theme } from './theme';

const GlobalStyles: React.FC = () => (
  <style>{`
    * {
      margin: 0;
      padding: 0;
      box-sizing: border-box;
    }

    html {
      font-size: 16px;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }

    body {
      font-family: ${theme.typography.fontFamily};
      background-color: ${theme.colors.background};
      color: ${theme.colors.text.primary};
      line-height: ${theme.typography.lineHeights.normal};
      min-height: 100vh;
    }

    h1, h2, h3, h4, h5, h6 {
      font-weight: ${theme.typography.weights.semibold};
      line-height: ${theme.typography.lineHeights.tight};
      color: ${theme.colors.primary};
    }

    h1 { font-size: ${theme.typography.sizes['5xl']}; }
    h2 { font-size: ${theme.typography.sizes['4xl']}; }
    h3 { font-size: ${theme.typography.sizes['3xl']}; }
    h4 { font-size: ${theme.typography.sizes['2xl']}; }
    h5 { font-size: ${theme.typography.sizes.xl}; }
    h6 { font-size: ${theme.typography.sizes.lg}; }

    @media (max-width: 768px) {
      h1 { font-size: ${theme.typography.sizes['4xl']}; }
      h2 { font-size: ${theme.typography.sizes['3xl']}; }
      h3 { font-size: ${theme.typography.sizes['2xl']}; }
      
      .mobile-nav { display: block !important; }
      .desktop-nav { display: none !important; }
    }

    a {
      color: ${theme.colors.primary};
      text-decoration: none;
      transition: color ${theme.transitions.fast};
    }

    a:hover {
      color: ${theme.colors.accent};
    }

    button {
      font-family: inherit;
      cursor: pointer;
      transition: all ${theme.transitions.base};
    }

    /* Scrollbar Styles */
    ::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

    ::-webkit-scrollbar-track {
      background: ${theme.colors.background};
    }

    ::-webkit-scrollbar-thumb {
      background: ${theme.colors.secondary};
      border-radius: ${theme.borderRadius.full};
    }

    ::-webkit-scrollbar-thumb:hover {
      background: ${theme.colors.primary};
    }

    /* Animation Classes */
    .fade-in {
      animation: fadeIn ${theme.transitions.base};
    }

    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }

    .slide-up {
      animation: slideUp ${theme.transitions.base};
    }

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(20px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
  `}</style>
);

export default GlobalStyles;